export enum HowToUse {
  UUID = '64ec15cb-3cb9-4f09-be60-dd72d5fe8abe',
}
